import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\lang\\switchboard\\next-shadcn-dashboard-starter\\app\\(auth)\\_components\\user-auth-form.tsx");
;
import(/* webpackMode: "eager" */ "D:\\lang\\switchboard\\next-shadcn-dashboard-starter\\node_modules\\next\\dist\\client\\link.js");
